/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type { TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse } from '../../types/TelegramGeoControllerGetCapitalWithoutCountryId.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { telegramGeoGetCapitalWithoutCountryId } from '../../methods/telegramGeoGetCapitalWithoutCountryId.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const telegramGeoGetCapitalWithoutCountryIdQueryKey = () => [{ url: '/api/telegram/geo/capital' }] as const;

export type TelegramGeoGetCapitalWithoutCountryIdQueryKey = ReturnType<
  typeof telegramGeoGetCapitalWithoutCountryIdQueryKey
>;

export function telegramGeoGetCapitalWithoutCountryIdQueryOptions(
  config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
  const queryKey = telegramGeoGetCapitalWithoutCountryIdQueryKey();
  return queryOptions<
    TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
    ResponseErrorConfig<Error>,
    TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return telegramGeoGetCapitalWithoutCountryId(config);
    },
  });
}

/**
 * {@link /api/telegram/geo/capital}
 */
export function useTelegramGeoGetCapitalWithoutCountryId<
  TData = TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
  TQueryData = TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
  TQueryKey extends QueryKey = TelegramGeoGetCapitalWithoutCountryIdQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        TelegramGeoControllerGetCapitalWithoutCountryIdQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? telegramGeoGetCapitalWithoutCountryIdQueryKey();

  const query = useQuery(
    {
      ...telegramGeoGetCapitalWithoutCountryIdQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
